import React from 'react';
import { Label, Select, SelectItem, DateInput } from '../../../components/ui';

function toDateInputValue(raw) {
  if (!raw) return '';
  try {
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) return '';
    return d.toISOString().slice(0, 10);
  } catch {
    return '';
  }
}

/**
 * Risk Assessment section fields.
 */
const DeviationRiskAssessmentSection = ({ formData, setFormData, fields = [] }) => {
  const getField = (name) => fields.find((f) => f.name === name);

  const riskAssessmentField = getField('riskAssessmentId');
  const riskAssessmentOptions = Array.isArray(riskAssessmentField?.options)
    ? riskAssessmentField.options
    : [];

  const riskAssessmentValue =
    formData?.riskAssessmentId != null && formData?.riskAssessmentId !== ''
      ? String(
          typeof formData.riskAssessmentId === 'object'
            ? formData.riskAssessmentId.id
            : formData.riskAssessmentId,
        )
      : '';

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="mb-0">
        <label className="inline-flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            checked={Boolean(formData?.riskAssessmentRequired)}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                riskAssessmentRequired: e.target.checked,
              }))
            }
          />
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
            {getField('riskAssessmentRequired')?.label ||
              'Risk Assessment Required'}
          </span>
        </label>
      </div>

      <div className="mb-0">
        <Label>
          {riskAssessmentField?.label || 'Risk Assessment'}
        </Label>
        <Select
          value={riskAssessmentValue}
          onChange={(e) => {
            const newValue = e.target.value
              ? parseInt(e.target.value, 10)
              : null;
            setFormData((prev) => ({
              ...prev,
              riskAssessmentId: newValue,
            }));
          }}
          placeholder="Select Risk Assessment"
          showClearButton
        >
          {riskAssessmentOptions.map((option) => {
            const optionValue =
              typeof option === 'object' ? option.value : option;
            const optionLabel =
              typeof option === 'object' ? option.label : option;
            return (
              <SelectItem key={String(optionValue)} value={String(optionValue)}>
                {optionLabel}
              </SelectItem>
            );
          })}
        </Select>
      </div>

      <div className="mb-0">
        <Label>
          {getField('riskAssessmentCompletedAt')?.label || 'RA Completed At'}
        </Label>
        <DateInput
          value={toDateInputValue(formData?.riskAssessmentCompletedAt)}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              riskAssessmentCompletedAt: e.target.value || null,
            }))
          }
        />
      </div>
    </div>
  );
};

export default DeviationRiskAssessmentSection;
